import React, { useState } from 'react';
//import FacebookLogin from 'react-facebook-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { 
	Button,
    Icon
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from "notistack";

import { loginSocial } from '../../store/slices/auth';

const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;

const FacebookLoginBtn = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
	const [load, setLoad] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

	const handleFacebookLogin = (response) => {
        
        setLoad(true)
        props.setOpen(true)

        let newName = response.name.split(" ", 2);
        const formData = new FormData();
                    
        formData.append('first_name', newName[0]);
        formData.append('last_name', newName[1]);
        formData.append('email', response.email ? response.email : response.id + '@facebook.com');
        formData.append('picture', response.picture.data.url);
        formData.append('provider', 'facebook');
        formData.append('provider_id', response.id);

        dispatch(loginSocial(formData))
            .unwrap()
            .then((res) => {
                props.setOpen(false)
                if(res.token) {
                    if(props.isModal) {
                        window.location.reload();
                    } else {
                        history.push("/user/dashboard");
                        window.location.reload();
                    }
                }
            })
            .catch((error) => {
                props.setOpen(false)
                if(error) {
                    enqueueSnackbar('Woops! Something went wrong!', {
                        variant: 'error',
                        autoHideDuration: 5000,
                    });
                }
            })
        
    }

	const componentClicked = () => {
		setLoad(true)
	}

    const handleFailure = (response) => {
        setLoad(false)
        props.setOpen(false)
        enqueueSnackbar('Woops! Something went wrong!', {
            variant: 'error',
            autoHideDuration: 5000,
        });
    }

    return (
        <FacebookLogin
            appId={FACEBOOK_APP_ID}
            autoLoad={load}
            fields="name,email,picture"
            callback={handleFacebookLogin}
            onFailure={handleFailure}
            authType="reauthenticate"
            render={renderProps => (
                <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                //    disabled={load}
                    onClick={componentClicked}
                    startIcon={<Icon>facebook</Icon>}
                    fullWidth={true}
                >
                    Continue with Facebook
                </Button>
            )} 
        />
    );
};

export default FacebookLoginBtn;